export const environment = {
  production: true,
  brand: 'cliente' as 'mosten' | 'cliente',
  baseURL:
    'https://api-agendamento-parkinghub-djhjcugcgtbzhfez.eastus2-01.azurewebsites.net/api/',
  sentry: {
    enabled: true,
    dsn: 'https://f6b28e81a1943386fdf49c3c86466a75@o4511627544231936.ingest.us.sentry.io/4511829319680005',
    environment: 'production' as const,
    release: 'parkinghubagendamento-web',
  },
};
